/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import './styles.scss'
import { TopMenu } from '../menu'
import { Icon, Button } from 'semantic-ui-react'
import { Person } from '../person'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'

import menuData from '../../../data/menu.json'

// TODO Set the correct article ID here
const ARTICLE_ID = '664619095561'

const parseJsonData = json => {
  return json.data
}

const isMobile = window.innerWidth < 768

export class AppComponent extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      menuOpen: false
    }
    this.menuRef = React.createRef()
    this.closeMenu = this.closeMenu.bind(this)
    this.openMenu = this.openMenu.bind(this)
  }

  openMenu() {
    this.setState({ menuOpen: true })
    this.menuRef.current.setMenuPosition()
    // Disable body scroll?? npm body-scroll-lock
  }

  closeMenu() {
    this.setState({ menuOpen: false })
    // Re-enable body scroll?? npm body-scroll-lock
  }

  render() {
    return (
      <div className='index'>
        <Masthead inverted articleId={ARTICLE_ID} />
        <ThemeSwitch />

        <header className='ui vertical very fitted titleImage segment'>
          <div className='ui container'>
            <div className='ui header'>
              <h1>26 Tipps fürs Leben</h1>
              <h2>
                Was können wir von einem Velomechaniker, einer
                Schneckenforscherin oder einer Apothekerin lernen? Praktische
                Ratschläge von Profis aus der Region.
              </h2>
            </div>
          </div>
        </header>
        <div className='content'>
          <div className='ui container'>
            <figcaption>Foto: Dominik Plüss</figcaption>
          </div>
        </div>

        <div className='ui vertical segment' style={{ paddingBottom: '0' }}>
          <div className='ui container'>
            <div className='ta metainfo'>
              <div className='ta author'>
                Dina Sambar, Nina Jecker, Markus Wüest, Dominik Heitz, Julia
                Konstantinidis, Julia Gisi, Raphaela Portmann, Rachel Hueber,
                Martin Furrer
              </div>
              <div className='ta updated'>Aktualisiert am 1. Februar 2022</div>
            </div>
          </div>
        </div>

        <div className='sticky-wrapper'>
          <div className='menu-toggle'>
            <div className='button-wrapper'>
              <Button onClick={this.openMenu}>
                <Icon name='bars' />
              </Button>
            </div>
          </div>

          <div className='content' onClick={isMobile ? this.closeMenu : null} />
          <div className='ui vertical segment'>
            <div className='ui container'>
              <div className='ui equal width stackable two column grid'>
                <Person
                  name='Paul Brunner'
                  image='paul-brunner'
                  format=''
                  function='Velomechaniker'
                  text='Die Reifen eines Velos sollten immer gut gepumpt sein. Sonst kostet das Fahren zu viel Kraft, und der Pneu geht kaputt. Auf den Pneus ist angegeben, mit wie viel Bar man sie aufpumpen sollte. Ein Rennvelo etwa braucht einen anderen Luftdruck als ein Mountainbike. Ist kein Messgerät vorhanden, gilt die Faustregel: So lange pumpen, bis der Pneu nicht mehr nachgibt, wenn er von Hand zusammengedrückt wird. (juk)'
                  key='nav-section-0'
                  index={0}
                />

                <Person
                  name='Martin Schermesser'
                  image='martin-schermesser'
                  format=''
                  function='Hautarzt'
                  text='Mein bester Tipp gegen Hautalterung und eine gesunde Haut: Nutzen Sie jeden Abend Retinol (2%) und am Morgen immer Sonnenschutz (mindestens 30) – auch im Winter. Sonnencreme verhindert Schäden im Erbgut der Haut, und Retinol (Vitamin A) kann Schäden auf Kernzellebene beheben und Zellen verjüngen. (dis)'
                  key='nav-section-1'
                  index={1}
                />

                <Person
                  name='Angelika Krebs'
                  image='angelika-krebs'
                  format=''
                  function='Philosophin'
                  text='Trau deinen Gefühlen, sie sind unsere Sensoren für das menschlich Gute. Sie blicken tiefer und weiter als der kühl kalkulierende Verstand. (ni)'
                  key='nav-section-2'
                  index={2}
                />

                <Person
                  name='Annka Dietrich'
                  image='annka-dietrich'
                  format=''
                  function='Scheidungsanwältin'
                  text='Grosszügig und wohlwollend – so scheidet man am besten. Das unterstütze ich. Doch wenn es harzt und klemmt: Wer nicht kämpft, hat bereits verloren! (ni)'
                  key='nav-section-3'
                  index={3}
                />

                <Person
                  name='Isabel Jawdat'
                  image='isabel-jawdat'
                  format=''
                  function='IT-Supporterin'
                  text='Das Internet vergisst nie: Ob man wirklich etwas online posten will, sollte man sich stets zweimal überlegen. Wer im Internet unterwegs ist, hinterlässt immer irgendwie Spuren. Wem Datenschutz wichtig ist, der bleibt vielleicht lieber offline. (rap)'
                  key='nav-section-4'
                  index={4}
                />

                <Person
                  name='Paul Betschart'
                  image='paul-betschart'
                  format=''
                  function='Blinder'
                  text='Dass das, was man ausschliesslich mit den Augen sieht, nicht immer der Wirklichkeit entspricht. Dass man die Angst, die man haben kann, als Energie einsetzt, vor der man keine Angst haben muss. Und dass man sich selber und anderen vertrauen muss und kann. (hei)'
                  key='nav-section-5'
                  index={5}
                />

                <Person
                  name='Vincent Gross'
                  image='vincent-gross'
                  format=''
                  function='Schlagersänger'
                  text='Wie Träume wahr werden: «Eine Rolltreppe, die runterfährt, hochgehen» – bleibst du nicht dran, kommst du nicht vorwärts! (hei)'
                  key='nav-section-6'
                  index={6}
                />

                <Person
                  name='Anna Bourquin'
                  image='anna-bourquin'
                  format=''
                  function='Apothekerin'
                  text='Jeder Mensch geht unterschiedlich mit seinen Krankheiten, Sorgen oder Unsicherheiten um. Dies hat mich gelehrt, Dinge aus einer anderen Sicht wahrzunehmen. Aus der Sicht des anderen. Wir sehen die Welt, wie wir sind. Nicht wie sie wirklich ist. (mw)'
                  key='nav-section-7'
                  index={7}
                />

                <Person
                  name='Marco Liechti'
                  image='marco-liechti'
                  format=''
                  function='Polizist'
                  text='Kommunizieren Sie mit Ihren Mitmenschen stets respektvoll, und begegnen Sie ihnen auf Augenhöhe. Beginnen Sie den Dialog, indem Sie zuerst ZUHÖREN. So konnte ich in meiner Polizeiarbeit schon viele schwierige und gefährliche Situationen beruhigen und weitere Eskalationen verhindern. (dis)'
                  key='nav-section-8'
                  index={8}
                />

                <Person
                  name='Ursi Senn'
                  image='ursi-senn'
                  format=''
                  function='Badangestellte'
                  text='Im Schwimmbecken kann es wild zu- und hergehen. Deshalb sind Rücksichtnahme und Toleranz das Wichtigste – wie auch sonst im Leben. Und: Bleibt am Wasser bei euren Kindern. Schon eine Tiefe von 20 Zentimetern genügt, dass ein Kleinkind ertrinken kann. (juk)'
                  key='nav-section-9'
                  index={9}
                />

                <Person
                  name='Chantal Metzger'
                  image='chantal-metzger'
                  format=''
                  function='Damenschneiderin'
                  text='Keine Zeit zum Pressieren – gut vorbereitet ist halb genäht. (rh)'
                  key='nav-section-10'
                  index={10}
                />

                <Person
                  name='Stephan Wullschleger'
                  image='stephan-wullschleger'
                  format=''
                  function='Richter'
                  text='«Der Blick auf die ‹Wahrheit› bestimmt sich nach dem Standpunkt, von dem man blickt.» Mit anderen Worten: In einem gerichtlichen Verfahren hört man alle Parteien. Nur so kann man sich ein abgerundetes Bild einer Sache machen. (mw)'
                  key='nav-section-11'
                  index={11}
                />

                <Person
                  name='Felix Schläfli'
                  image='felix-schlaefli'
                  format=''
                  function='Palliativpfleger'
                  text='Sprechen Sie mit nahen Angehörigen über Ihre Vorstellungen und Befürchtungen zum Thema Krankheit und Sterben. Offenheit, Realismus und eine Portion Selbstironie helfen dabei. Selbstbestimmung ist uns heilig, doch das Unumgängliche wie den Tod blenden wir gerne hartnäckig aus. Mit einer Patientenverfügung unterstützen Sie Ihre Vertrauenspersonen, falls diese für Sie medizinische Entscheidungen treffen müssen. (dis)'
                  key='nav-section-12'
                  index={12}
                />

                <Person
                  name='Sam Keller'
                  image='sam-keller'
                  format=''
                  function='Museumsdirektor'
                  text='«Das Universum ist voll wunderbarer Dinge, die geduldig darauf warten, dass unsere Sinne schärfer werden», hat der englische Dichter Eden Phillpotts geschrieben. Eine Lebensweisheit, die mich schon lange begleitet. (mw)'
                  key='nav-section-13'
                  index={13}
                />

                <Person
                  name='Emma Kistemaker und <nobr>Lorena Madarena</nobr>'
                  image='kistemaker-madarena'
                  format=''
                  function='Modeschöpferduo'
                  text='«Richtig» shoppen heisst auch mal, nicht zu shoppen. Brauchst du etwas für einen speziellen Anlass? Leihe dir Kleidung bei Freunden und Verwandten, statt sie neu zu kaufen. Das gibt dem Kleidungsstück eine neue Erinnerung. (jug)'
                  key='nav-section-14'
                  index={14}
                />
                <Person
                  name='Marion Mertens'
                  image='marion-mertens'
                  format=''
                  function='Schneckenforscherin'
                  text='Gerade in der manchmal etwas hektischen Zeit halte ich es mit dem chinesischen Philosophen Laotse: «Die Natur eilt nicht und dennoch wird alles erreicht.» (hei)'
                  key='nav-section-15'
                  index={15}
                />

                <Person
                  name='Sergio Bustinduy'
                  image='sergio-bustinduy'
                  format=''
                  function='Karate-Trainer'
                  text='Der beste Grund, Karate zu lernen, ist, Charakter zu entwickeln. Werde zuerst ein guter, erst dann ein starker Mensch. (ni)'
                  key='nav-section-16'
                  index={16}
                />

                <Person
                  name='Philipp Howald'
                  image='philipp-howald'
                  format=''
                  function='Architekt'
                  text='Man hat alles geplant und eine ganz klare Vorstellung davon, wie ein Projekt verlaufen wird. Meistens kommt es dann aber anders. Mit der nötigen Offenheit und Gelassenheit entsteht oft Spannendes. Das kann man gut auch auf andere Lebensbereiche übertragen. (jug)'
                  key='nav-section-17'
                  index={17}
                />

                <Person
                  name='Andrea Niggemann-Brunner'
                  image='andrea-niggemann'
                  format=''
                  function='Gynäkologin'
                  text='Treiben Sie Sport. Regelmässige sportliche Aktivität schützt nachweislich vor vielen Frauenleiden wie zum Beispiel  Menstruationsbeschwerden, Wechseljahrbeschwerden und sogar Brustkrebs. (ni)'
                  key='nav-section-18'
                  index={18}
                />

                <Person
                  name='Sven Hugentobler'
                  image='sven-hugentobler'
                  format=''
                  function='Finanzexperte'
                  text='Warten Sie nicht bis Dezember, um sich Gedanken über Ihre 3. Säule zu machen. Richten Sie einen monatlichen Dauerauftrag direkt auf Ihr Säule-3a-Konto ein. Falls Sie es finanziell vermögen, weisen Sie Ihre Bank an, jeweils gleich am Anfang eines Jahres den Maximalbetrag zu transferieren, somit wirft Ihr Säule-3a-Konto oder Fonds bereits früher eine Rendite ab und Sie verpassen den Steuerabzug nie mehr. (dis)'
                  key='nav-section-19'
                  index={19}
                />

                <Person
                  name='Stéphanie Girod'
                  image='stephanie-girod'
                  format=''
                  function='Physiotherapeutin'
                  text='Man spricht von Work-Life-Balance, doch für mich wird in dieser Gleichung der Körper und das Beachten seiner Signale vernachlässigt. Eine ausgewogene Mischung von Belastung, Bewegung und genügend Erholung ergeben die optimale Work-Life-Body-Balance. (juk)'
                  key='nav-section-20'
                  index={20}
                />

                <Person
                  name='Monika Röder'
                  image='monika-roeder'
                  format=''
                  function='Paartherapeutin'
                  text='Partnerschaft gelingt, wenn wir beides hinkriegen: Selbstfürsorge und das Ernstnehmen eigener Bedürfnisse einerseits – und das Interesse am anderen und den Versuch, ihn zu verstehen, andererseits. (ni)'
                  key='nav-section-21'
                  index={21}
                />

                <Person
                  name='Lars Hänggi'
                  image='lars-haenggi'
                  format=''
                  function='Student'
                  text='Während der Onlinevorlesungen das Handy am besten einfach aufs Bett schmeissen, dann lenkt es auch nicht ab. Und wenn du die Vorlesung im Bett hörst, schalte das Handy komplett aus. (rh)'
                  key='nav-section-22'
                  index={22}
                />

                <Person
                  name='Marco D’Amico'
                  image='marco-damico'
                  format=''
                  function='Fahrlehrer'
                  text='Wir alle hatten mal ein blaues L auf dem Auto und waren extrem nervös. Vor allem dann, wenn hinter uns einer hupte – doch es ging nicht schneller, im Gegenteil. Deshalb gilt: Denke mit, du bist nicht allein auf der Strasse, sie gehört uns allen. Ob mit dem Velo, Motorrad oder Auto: Wir wollen ohne Stress und gesund unser Fahrziel erreichen. (mfu)'
                  key='nav-section-23'
                  index={23}
                />

                <Person
                  name='Dorothea Jäger'
                  image='dorothea-jaeger'
                  format=''
                  function='Hebamme'
                  text='Zeugung, Schwangerschaft, Geburt: Die Entstehung eines Kindes ist etwas vom Ursprünglichsten, was es heute noch gibt. Das sollten wir trotz der medizinischen Möglichkeiten, die wir haben, nicht vergessen. Der weibliche Körper bewältigt diesen Prozess seit Jahrtausenden von Natur aus bestens. Darauf zu vertrauen, ist wichtig. (juk)'
                  key='nav-section-24'
                  index={24}
                />

                <Person
                  name='Isidor Huber'
                  image='isidor-huber'
                  format=''
                  function='Schuldirektor'
                  text='Es gibt genug Schlechtes in dieser Welt – versuche, etwas Positives, Konstruktives und Menschenfreundliches zu machen. Und dies, wenn möglich, mit einem Schuss Humor. (rh)'
                  key='nav-section-25'
                  index={25}
                />
              </div>
            </div>
          </div>
        </div>

        <Footer
          articleId={ARTICLE_ID}
          hidePortfolioTeaser
          questions={[
            'Wie informativ war der Beitrag?',
            'Wie gefällt Ihnen die Gestaltung?'
          ]}
          credits={[
            [
              'Redaktion',
              'Dina Sambar (dis), Nina Jecker (ni), Markus Wüest (mw), Dominik Heitz (hei), Julia Konstantinidis (juk), Julia Gisi( jug), Raphaela Portmann (rap), Rachel Hueber (rh), Martin Furrer (mfu)'
            ],
            ['Digitale Umsetzung', 'Mathias Lutz']
          ]}
        />

        <TopMenu
          ref={this.menuRef}
          menuOpen={this.state.menuOpen}
          closeMenu={this.closeMenu}
          openMenu={this.openMenu}
          menuData={parseJsonData(menuData)}
        />
      </div>
    )
  }
}
